import { Helpers } from '../../helpers';
import { IField } from '../../interfaces/ifield';
import { ProjectPondParameter } from '../project-pond-parameter';

export class FieldBase {
  FieldId: number;
  Description: string;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ProjectPondParameters_Field?: Array<ProjectPondParameter> | null;

  constructor(item?: IField) {
    if (item) {

      this.FieldId = item.FieldId;
      this.Description = item.Description;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ProjectPondParameters_Field = Helpers.createClassArray(ProjectPondParameter, item.ProjectPondParameters_Field);
    }
  }
}